(function () {
  if (customElements.get('truncated-description')) return;

  class TruncatedDescription extends HTMLElement {
    connectedCallback() {
      this.content = this.querySelector('.td__content');
      this.button = this.querySelector('.td__btn');
      this.label = this.querySelector('.td__btn-text');
      if (!this.content || !this.button) return;

      // Start collapsed so the clamp is applied before we measure.
      this.classList.add('is-collapsed');
      this.button.addEventListener('click', this.onToggle.bind(this));

      this.checkOverflow();

      // Images and web fonts change the height after first paint.
      if ('ResizeObserver' in window) {
        this.observer = new ResizeObserver(this.checkOverflow.bind(this));
        this.observer.observe(this.content);
      } else {
        window.addEventListener('load', this.checkOverflow.bind(this));
      }
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
    }

    // Only offer the toggle when the content is actually taller than the clamp.
    checkOverflow() {
      if (this.classList.contains('is-expanded')) return;
      var overflows = this.content.scrollHeight - this.content.clientHeight > 1;
      this.button.hidden = !overflows;
    }

    onToggle() {
      var expanded = this.classList.toggle('is-expanded');
      this.classList.toggle('is-collapsed', !expanded);
      this.button.setAttribute('aria-expanded', String(expanded));

      if (this.label) {
        var next = expanded ? this.label.dataset.less : this.label.dataset.more;
        if (next) this.label.textContent = next;
      }

      // Collapsing from below the fold would strand the viewport past the block.
      if (!expanded) {
        var top = this.getBoundingClientRect().top;
        if (top < 0) this.scrollIntoView({ block: 'start', behavior: 'smooth' });
      }
    }
  }

  customElements.define('truncated-description', TruncatedDescription);
})();
